import type { SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export const exportIconButtonSx: SxProps<Theme> = {
  width: '2.5rem',
  height: '2.5rem',
  '&:hover .icon-active': { opacity: 1 },
  '&:hover .icon-default': { opacity: 0 },
  background: (theme) => theme.palette.primary.contrastBackground,
  '&:hover': {
    cursor: 'pointer',
    boxShadow: (theme) => theme.customShadows.iconButton,
  },
  '& .icon-active': {
    opacity: 0,
    top: '50%',
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, -55%)',
  },
};
